import { get } from 'lodash';
import React, { useMemo } from 'react';

import Avatar from 'components/Misc/Avatar';
import { Button } from 'components/Misc/Form';
import { AverageMark } from 'components/Ui/Mark';
import { Title } from 'components/Misc/Typography';

import Grade from 'containers/Teacher/Subjects/Profile/Students/Grade';

const Student = ({ student }) => {
	const avarage = useMemo(() => {
		const calculation = student.grades?.reduce((result, grade) => {
			grade.marks.forEach(mark => {
				if (mark.type === 'transferred') {
					result.sum += +mark.mark;
					result.count += 1;
				}
			});

			grade.courses.forEach(course => {
				const take = get(course, 'takes.0');

				if (take?.mark) {
					result.sum += +take.mark;
					result.count += 1;
				}
			});

			return result;
		}, { sum: 0, count: 0 });

		const avg = Number(calculation.sum / calculation.count).toFixed(1);

		return isNaN(avg) ? 'nv' : avg;
	}, [student]);

	return (
		<div className="py-3 px-4 space-y-3">
			<div className="flex items-center space-x-2">
				<div className="flex flex-1 items-center space-x-2">
					<Avatar
						small
						src={student.avatar}
						alt={student.name}
						online={student.online}
					/>

					<Title
						title={`${student.name} ${student.surname}`}
						className="flex-1"
					/>
				</div>

				<div className="flex items-center space-x-2">
					<div className="text-sm font-bold text-neutral-700 dark:text-neutral-200">
						Vidējais vērtējums
					</div>

					<AverageMark mark={avarage} />
				</div>

				<Button
					small
					square
					icon="link"
					to={`/users/${student.id}`}
				/>
			</div>

			<div className="flex gap-4">
				{student.grades.map(grade =>
					<Grade key={grade.id} grade={grade} studentId={student.id} />
				)}
			</div>
		</div>
	);
};

export default Student;